type Variant = {
  name: string
  price: number
  sku: string
}

type ProductVariantsProps = {
  variants: any[]
  currentVariant: any | null
  selectedVariant: number
  setSelectedVariant: (index: number) => void
}

export const VariantsSection = ({
  variants,
  currentVariant,
  setSelectedVariant,
  selectedVariant,
}: ProductVariantsProps) => {
  const getVariantProperties = () => {
    if (!variants || variants.length === 0) return []

    const propertyKeys = new Set<string>()

    variants.forEach((variant) => {
      Object.keys(variant).forEach((key) => {
        if (!["name", "price", "sku"].includes(key)) {
          propertyKeys.add(key)
        }
      })
    })

    return Array.from(propertyKeys)
  }

  // Check if variants have price differences
  const hasPriceDifferences = () => {
    if (!variants || variants.length <= 1) return false

    const firstPrice = variants[0]?.price
    return variants.some((v) => v.price !== firstPrice)
  }

  return (
    <div className="space-y-4">
      <h3 className="font-medium">Select Option:</h3>
      <div className="flex flex-wrap gap-2">
        {variants.map((variant, index) => (
          <button
            key={variant.sku || index}
            onClick={() => setSelectedVariant(index)}
            className={`rounded-md border px-4 py-2 text-sm transition-all ${
              currentVariant?.sku === variant.sku
                ? "border-blue-600 bg-blue-50 text-blue-600"
                : "border-gray-300 hover:border-gray-400"
            }`}
          >
            {variant.name}
          </button>
        ))}
      </div>

      {/* Display additional variant properties if they exist */}
      {variants && variants[selectedVariant] && getVariantProperties().length > 0 && (
        <div className="mt-3 space-y-2">
          {getVariantProperties().map((propKey) => (
            <div key={propKey} className="flex text-sm">
              <span className="mr-2 font-medium capitalize">{propKey.replace(/([A-Z])/g, " $1").trim()}:</span>
              <span className="text-gray-700">{variants![selectedVariant][propKey]}</span>
            </div>
          ))}
        </div>
      )}

      {/* Price difference note if applicable */}
      {hasPriceDifferences() && (
        <p className="text-sm italic text-gray-500 dark:text-gray-200">* Price may vary based on selection</p>
      )}
    </div>
  )
}
